/**
 * return a `.swiper-slide`
 *
 * must exists a template under `._template-block`
 */
const wrapSwiperSlide = (content) => {
	const template = document.createElement('div');
	template.setAttribute('class', 'swiper-slide');

	template.appendChild(content);

	return template;
};

export default wrapSwiperSlide;



// WEBPACK FOOTER //
// ./src/js/about/wrapSwiperSlide.js